import * as React from 'react';
import Head from 'next/head';
import { useSelector } from 'react-redux';

import { Layout } from 'components/Layout/Layout';
import { PopupMessage } from 'components/PopupMessage/PopupMessage';
import { TutorialInfomationPopUpMessage } from 'components/TutorialPopUpMessage/TutorialInfomationPopUpMessage';
import { ReduxState } from 'ducks';

import { BookingWidgetPage } from './BookingWidgetPage';
import { HeadRawHtmlRenderer } from 'components/HeadRawHtmlRenderer';

type Props = {
  children: React.ReactNode;
};

export const BookingWidgetLayout = ({ children }: Props) => {
  const shouldUseCustomTopPage = useSelector(
    (state: ReduxState) => state.server.settings.all?.is_custom_top_page_enabled
  );
  const topPageData = useSelector((state: ReduxState) => state.server.customTopPage.page);

  return (
    <Layout>
      {shouldUseCustomTopPage && topPageData?.headRawHtml && (
        <Head>
          <HeadRawHtmlRenderer html={topPageData.headRawHtml} />
        </Head>
      )}
      <PopupMessage />
      <TutorialInfomationPopUpMessage />
      <BookingWidgetPage>{children}</BookingWidgetPage>
    </Layout>
  );
};
